export const questionDelays = {
  intermissionDelay: 'INTERMISSION_DELAY',
  billboardDelay: 'BILLBOARD_DELAY',
  loadingPanelDelay: 'LOADING_PANEL_DELAY'
}
